<mat-form-field>
  <mat-label>DateTime Control Input</mat-label>
  <input matInput [ngModel]="controlValue|async" (ngModelChange)="controlValue.next($event)" name="controlValue" type="datetime-local">
</mat-form-field>

